'use client'
import { Flex } from 'antd'
import styles from './style.module.scss'
import { Authentication } from 'core/components/Authenticate'
import { useLocale } from 'core/components/Locale'
import cls from 'classnames'
import { useCopy } from '@/hooks/useCopy'
import { useHCRouter } from '@/components/HCNextLink'
import { useIdentity, IdentityStatus } from 'core/controller/auth/user'
import React from 'react'

const Overview = () => {
  const t = useLocale()
  const router = useHCRouter()

  const { copyTextWithNotification } = useCopy()
  const onCopy = (value: string) => {
    copyTextWithNotification(value)
  }

  const identity = useIdentity(true)

  return (
    <Authentication
      allow={({ loginData }) => {
        return (
          <div className={styles.userPanelHeader}>
            <Flex align="center">
              <div className={cls([styles.userIcon1])}>
                {loginData?.photo ? (
                  // eslint-disable-next-line @next/next/no-img-element
                  <img src={loginData?.photo} alt="" />
                ) : (
                  <i className={styles.defaultUserIcon}></i>
                )}
              </div>
              <div className={styles.userHeader}>
                <div className={styles.userTitle}>
                  <span>{loginData.fnickname}</span>

                  <div
                    className={cls([styles.vip, styles[`vip${loginData.vipLevel}`]])}
                    onClick={() => {
                      router.push(`/vip`)
                    }}
                  >
                    <i className={styles.vipIcon}></i>
                    <i className={styles.vipNumIcon}></i>
                    {loginData?.vipType === 2 && <span>{t('vip_003')}</span>}
                  </div>
                </div>
                <div className={styles.userTitle2}>
                  UID: {loginData.fid}
                  <i
                    className={cls('iconfont', 'iconfuzhi f12', styles.copy)}
                    onClick={() => onCopy(loginData.fid)}
                  ></i>
                </div>
                <div
                  className={cls([
                    styles.identity,
                    styles[`identity_type_${identity?.type}`],
                    styles[`identity_status_${identity?.status.join('_')}`],
                  ])}
                >
                  {identity?.status.includes(IdentityStatus.WaitAudit) ? (
                    /* 待审核 */
                    <i className="iconfont iconshenhezhong f12" style={{ color: '#FC802B' }}></i>
                  ) : identity?.status.includes(IdentityStatus.PassAudit) ? (
                    /* 已认证 */
                    <i className="iconfont iconyirenzheng f12" style={{ color: '#00C087' }}></i>
                  ) : (
                    /* 未认证 */
                    <i className="iconfont iconweirenzhengtishi f12" style={{ color: '#FC802B' }}></i>
                  )}
                  <div className={styles.label}>{t(identity?.key)}</div>
                </div>

                <div className={styles.isAuthenticated}></div>
              </div>
            </Flex>
          </div>
        )
      }}
    />
  )
}

export default Overview
